import { render } from "./terms-fetcher.vue?vue&type=template&id=be3d7b36&ts=true"
import script from "./terms-fetcher.vue?vue&type=script&lang=ts"
export * from "./terms-fetcher.vue?vue&type=script&lang=ts"

import "./terms-fetcher.vue?vue&type=style&index=0&id=be3d7b36&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__